<template>
  <!-- Modal -->
  <div
    class="modal"
    id="add-waiting"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Add To Waiting List</h3>
        </div>
        <div class="modal-body bg-white">
          <div class="row">
            <div class="col-md-12 mb-10">
              <div class="icheck-danger">
                <input
                  type="radio"
                  checked
                  name="waiting_reason"
                  value="support_fabric_na"
                  id="waiting-reason1"
                />
                <label for="waiting-reason1">Support: Fabric n/a</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="support_other"
                  id="waiting-reason2"
                />
                <label for="waiting-reason2">Support: Other</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="pattern"
                  id="waiting-reason3"
                />
                <label for="waiting-reason3">Pattern</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="s&n"
                  id="waiting-reason4"
                />
                <label for="waiting-reason4">S&N</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="fabric"
                  id="waiting-reason5"
                />
                <label for="waiting-reason5">Fabric</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="other"
                  id="waiting-reason6"
                />
                <label for="waiting-reason6">Other</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="hold"
                  id="waiting-reason7"
                />
                <label for="waiting-reason7">Hold</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="special_request"
                  id="waiting-reason8"
                />
                <label for="waiting-reason8">Special Request</label>
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="waiting_prepayment"
                  id="waiting-reason9"
                />
                <label for="waiting-reason9"
                  >Waiting Prepayment Confirmation</label
                >
              </div>
              <div class="icheck-danger">
                <input
                  type="radio"
                  name="waiting_reason"
                  value="dont_touch"
                  id="waiting-reason10"
                />
                <label for="waiting-reason10">Don't Touch</label>
              </div>
            </div>
            <div class="col-md-12 mt-10">
              <textarea
                class="form-control"
                id="waiting_notes"
                cols="30"
                rows="4"
                placeholder="Remark ......."
              ></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger" data-dismiss="modal">
            CANCEL
          </button>
          <button type="button" class="btn btn-primary" @click="addToWaiting()">
            CONFIRM
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addToWaiting() {
      let waiting_reason = $("input[name='waiting_reason']:checked").val();
      let waiting_notes = $("#waiting_notes").val();
      this.$emit("submit", { waiting_reason, waiting_notes });
    },
  },
};
</script>
